'use client'
import { __awaiter } from '../../../../../../_virtual/_tslib.js';
import { CookieInvalidError } from '@dynamic-labs/utils';
import { getAuthenticatedUser } from '../../../../data/api/user/user.js';
import { getUser } from '../../../../store/state/user/user.js';
import '../../../constants/values.js';
import { isCookieEnabled } from '../../../functions/isCookieEnabled/isCookieEnabled.js';
import '../../../../store/state/projectSettings/projectSettings.js';
import { getAuthToken } from '../../../functions/getAuthToken/getAuthToken.js';

/**
 * Detects mismatch between user and auth token.
 * @returns true if there is no mismatch.
 */
const handleUserDataOutOfSync = (_a) => __awaiter(void 0, [_a], void 0, function* ({ environmentId, logout, projectSettings, }) {
    const cookieEnabled = isCookieEnabled(projectSettings);
    const authToken = getAuthToken();
    const user = getUser();
    if (authToken || !user) {
        return true;
    }
    if (user && !authToken && cookieEnabled) {
        try {
            yield getAuthenticatedUser({ environmentId });
        }
        catch (e) {
            if (e instanceof CookieInvalidError) {
                yield logout('user auth cookie invalid', {
                    authToken,
                    user,
                });
                return false;
            }
        }
        return true;
    }
    yield logout('user data out of sync', {
        authToken,
        user,
    });
    return false;
});

export { handleUserDataOutOfSync };
